import React from 'react';
import { Box, Typography } from '@mui/material';
import ApiParametersTable from '../ApiParametersTable';
import ApiEndpointDisplay from '../ApiEndpointDisplay';
import ApiResponseExamples from '../ApiResponseExamples';
import ApiRequestExamples from '../ApiRequestExamples';

const VehicleListApi: React.FC = () => {
    const parameters = [
        { type: 'HEAD', name: 'Authorization', dataType: 'string', required: true },
    ];

    return (
        <Box className="flex flex-col border-b border-gray-200">
            <Typography variant="h6" marginBottom={1} fontWeight={600} fontSize={16} id="vehicle-list">
               GET ALL VEHICLE LIST
            </Typography>
            
            <Typography variant='body2' marginBottom={2} fontSize={14} fontWeight={400}>
                To retrieve all vehicle list, you must send a GET request. This request requires an Authorization token in the headers.
            </Typography>

            <Typography variant='body2' marginBottom={1} fontSize={16} fontWeight={600}>Request</Typography>
            <ApiEndpointDisplay 
                method="GET" 
                url="https://backend.novusomnifleet.com/api/client/v1/fetch-vehicle-list" 
            />

            <ApiParametersTable parameters={parameters} />

            <ApiRequestExamples
                examples={[
                    {
                    type: "headers",
                    headers: [
                        {
                        key: "Authorization",
                        value:
                            "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJJQ1NBIiwidXNlcklkIjoiNjdkOTBkMDdlNGNhZTU3MDEwMzQyYzA4Iiwicm9sZXMiOiJST0xFX0ZMRUVUX01BTkFHRVIiLCJpYXQiOjE3NTQzNzIyNjksImV4cCI6MTc1NDQwODI2OX0.NItAkAwXNGKxoAsUTZSwB0lzFPHgW3I4ZwpLEY4c-Lo"
                        }
                    ],
                    label: "Request Headers"
                    }
                ]}
            />


            <ApiResponseExamples 
                examples={[
                    {
                        status: '200',
                        description: 'Success',
                        response: `{
                                    "data": [
                                        "vehicle1",
                                        "vehicle2"
                                    ],
                                    "message": "Vehicle List Fetched Successfully",
                                    "status": 200
                                    }`
                    },
                    {
                        status: '401',
                        description: 'Unauthorized',
                        response: `{
                                    "success": false,
                                    "message": "Invalid username or password"
                                    }`
                    },
                    {
                        status: '500',
                        description: 'Server Error',
                        response: `{
                                    "success": false,
                                    "message": "An internal server error occurred"
                                    }`
                    }
                ]}
            />
        </Box>
    );
};

export default VehicleListApi;
